import { Flex, Form } from 'antd';
import styles from './forgot-password-form.module.scss';
import TextField from '../form/text-field/text-field';
import Label from '../form/label/label';
import { Button } from '../button/button';

export type ForgotPasswordFieldType = {
  email: string;
};

interface ForgotPasswordFormProps {
  onSubmit: (value: ForgotPasswordFieldType) => void;
  error?: string;
  isLoading?: boolean;
}

export function ForgotPasswordForm({ onSubmit, error, isLoading }: ForgotPasswordFormProps) {
  const [form] = Form.useForm();
  return (
    <Flex className={styles.container} vertical gap={24}>
      <h3 className={styles.title}>Forgot password?</h3>
      <p className={styles.paragraph}>
        Enter your email address and we will send you instructions to reset your password.
      </p>
      <Form form={form} onFinish={onSubmit} autoComplete="off">
        <Label text="Email address" />
        <Form.Item<ForgotPasswordFieldType>
          name="email"
          rules={[
            { required: true, message: 'Please input your email!' },
            { type: 'email', message: 'Please enter a valid email address!' },
          ]}
        >
          <TextField
            autoComplete="email"
            onPaste={(e) => {
              const pastedValue = e.clipboardData.getData('Text');
              form.setFieldsValue({ email: pastedValue.trim() });
              e.preventDefault();
            }}
          />
        </Form.Item>
        <Form.Item>
          <Button size="large" type="primary" htmlType="submit" loading={isLoading} block>
            Send Reset Instructions
          </Button>
        </Form.Item>
        {error && <p>{error}</p>}
      </Form>
    </Flex>
  );
}
